/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Address } from './Address';
import type { OnlinePaymentMethod } from './OnlinePaymentMethod';
export type CreateSeminarCheckoutSessionPayload = {
    onlinePaymentMethod?: OnlinePaymentMethod;
    email: string;
    firstName: string;
    lastName: string;
    fingerprint: string;
    phoneNumber?: string;
    address?: Address;
    birthdate?: string;
    seats?: number;
    note?: string;
    source?: CreateSeminarCheckoutSessionPayload.source;
    returnUrl?: string;
};
export namespace CreateSeminarCheckoutSessionPayload {
    export enum source {
        WIDGET = 'widget',
        PUBLIC_PAGE = 'public_page',
    }
}

